import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;

/**
 * Axios client for the MPS API.
 *
 * Auth transports (Phase 28i — Feb 2026):
 *   1. Legacy — `Authorization: Bearer <jwt>` read from `localStorage.mps_token`.
 *   2. New — HttpOnly session cookie `mps_session` set on login. Cookie is
 *      sent automatically because we opt in with `withCredentials: true`.
 *
 * CSRF — When a cookie-based session exists (detectable via the non-HttpOnly
 * `mps_csrf` cookie), we automatically echo its value as `X-CSRF-Token` on
 * unsafe methods (POST/PUT/PATCH/DELETE). Requests that authenticate with
 * Bearer only don't need the header.
 */
export const api = axios.create({
  baseURL: `${BASE}/api`,
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
});

const UNSAFE = new Set(["post", "put", "patch", "delete"]);

const readCookie = (name) => {
  if (typeof document === "undefined") return null;
  const match = document.cookie
    .split(";")
    .map((c) => c.trim())
    .find((c) => c.startsWith(name + "="));
  return match ? decodeURIComponent(match.slice(name.length + 1)) : null;
};

api.interceptors.request.use((config) => {
  const token = typeof localStorage !== "undefined" ? localStorage.getItem("mps_token") : null;
  if (token && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  if (config.method && UNSAFE.has(String(config.method).toLowerCase())) {
    const csrf = readCookie("mps_csrf");
    if (csrf && !config.headers["X-CSRF-Token"]) {
      config.headers["X-CSRF-Token"] = csrf;
    }
  }
  return config;
});

export const API_BASE = `${BASE}/api`;
